<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

						<div class="modal-header row" style="justify-content: flex-end;">
							<div class="col">
								<button type="button" class="close" @click="$emit('closeModal')">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
						<!-- Start Modal Body -->
						<div class="modal-body">
							<h4 class="title">Estimasi Penambahan Sparepart</h4>

							<div class="row row-space">
								<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
									<div class="input-group">
										<label class="label">Pilih Tipe Sparepart<span style="color: red;">*</span></label>
									</div>
								</div>
							</div>
							<div class="row row-space pl-3" style="margin-top:-15px">
								
								<div class="col-md-8 col-12 row" style="padding-top:6px;">
									
									<div class="col" style="padding-right:0">
										<button 
											style="border-radius : 6px 0px 0px 6px"
											type="button" 
											class="w-100 btn" 
											:class="{'btn-outline-primary' : sparepart_type != 'J', 'btn-primary' : sparepart_type == 'J'}" 
											@click="sparepart_type = 'J'"
										>
											Jasa
										</button>
									</div>
									<div class="col" style="padding-left:0">
										<button 
											style="border-radius : 0px 6px 6px 0px"
											type="button" 
											class="w-100 btn" 
											:class="{'btn-outline-primary' : sparepart_type != 'P', 'btn-primary' : sparepart_type == 'P'}" 
											@click="sparepart_type = 'P'"
										>
											Part
										</button>
									</div>
								</div>
							</div>

							<div v-if="sparepart_type == 'J'">
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Pilih Jasa<span style="color: red;">*</span></label>
											<multi-select
											v-if="sparepartMaster"
											class="mt-1"
											:options="sparepartMaster[sparepart_type].map(x => x.id).sort()"
											:custom-label="opt => sparepartMaster[sparepart_type].find(x => x.id == opt).alias"
											placeholder="Pilih Sparepart Mobil"
											v-model="selectSparepart"
											:maxHeight="200"
											/>
										</div>
									</div>
								</div>
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Pilih Jasa Extension</label>
											<multi-select
											v-if="extensionList"
											:disabled="extensionList[0] == 'No Extension Available'"
											class="mt-1"
											:options="extensionList"
											placeholder="Pilih Extension Jasa"
											v-model="data.extension"
											:maxHeight="200"
											/>
										</div>
									</div>
								</div>
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Jumlah Sparepart<span style="color: red;">*</span></label>
											<input disabled class="input--style-4" type="number" :step="'1'"  v-model="data.amount">
										</div>
									</div>
								</div>
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Tipe Jasa<span style="color: red;">*</span></label>
											<multi-select
											class="mt-1"
											:options="['G/C' , 'R/C' , 'Special Repair', 'Inspeksi', 'B/P']"
											placeholder="Pilih Tipe Jasa"
											v-model="data.type"
											:maxHeight="200"
											/>
										</div>
									</div>
								</div>
								
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Deskripsi Jasa</label>
											<input type="text" class="input--style-4" v-model="data.part_number"/>
											<div class="row mt-2">
												<div class="col-4" v-for="description in descriptionList">
													<button class="btn btn-secondary" type="button" @click="updateDescription(description)">{{description}}</button>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="row row-space">
									<div class="col-12">
										<div class="input-group">
											<label class="label">Pilih Sparepart Size<span style="color: red;">*</span></label>
											<multi-select
											class="mt-1"
											:options="options.sparepartSizes.map(x => x.id).sort()"
											:custom-label="opt => options.sparepartSizes.find(x => x.id == opt).name"
											label="name"
											placeholder="Pilih Sparepart Mobil"
											v-model="data.sparepart_size"
											/>
										</div>
									</div>
								</div>
								<!-- :custom-label="opt => options.brand.find(x => x.id == opt).name" -->
								<div v-if="data.sparepart_id" class="row row-space">
									<div class="col-12">
										<div class="input-group">
											<label class="label">Rincian Sparepart</label>
											<table class="table table-borderless">
												<tr>
													<td>Sparepart ID</td>
													<td>:</td>
													<td>{{data.sparepart_id.id}}</td>
												</tr>
											</table>
										</div>
									</div>

									<div class="col-12" v-if="sparepart_type == 'J'">
										<div class="input-group" v-if="price == 0">
											<!-- Insert New Pricelist-->
											<label class="label">Tambah Price List Jasa <span style="color:red">*</span></label>
											<input type="text" v-model="addPriceList" class="input--style-4" />
											<button
												class="btn btn-info"
												@click="addPriceListDB"
											>
												Tambah Price List
											</button>
										</div>

										<div class="input-group" v-else>
											<!-- Modify Price with Pricelist as Base -->
											<!-- {{price}} -->
											<label class="label">Set Harga Jasa <span style="color:red">*</span></label>
											<input type="text" v-model="data.price_per_item" class="input--style-4" />

										</div>
										<div class="row row-space">
											<div class="form-check form-check-inline col-12">
												<input class="form-check-input" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="data.without_ppn">
												<label class="form-check-label" for="inlineCheckbox1">Non PPN</label>
											</div>
										</div>
										<!-- {{data.without_ppn}} -->
										<div class="row row-space">
											<div class="form-check form-check-inline col-12">
												<input class="form-check-input" :disabled="data.without_ppn" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="data.ppn_included">
												<label class="form-check-label"  for="inlineCheckbox1">Harga Termasuk PPN</label>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-else>
								<!-- <div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Pilih Sparepart Attachments<span style="color: red;">*</span></label>
											<multi-select
											class="mt-1"
											:options="options.sparepartAttachments.map(x => x.id)"
											:custom-label="opt => options.sparepartAttachments.find(x => x.id == opt).name"
											placeholder="Pilih Sparepart Attachment"
											v-model="data.attachment_id"
											/>
										</div>
									</div>
								</div> -->
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Pilih Part<span style="color: red;">*</span></label>
											<multi-select
											v-if="sparepartMaster"
											class="mt-1"
											:options="sparepartMaster[sparepart_type].map(x => x.id).sort()"
											:custom-label="opt => sparepartMaster[sparepart_type].find(x => x.id == opt).alias"
											placeholder="Pilih Sparepart Mobil"
											v-model="selectSparepart"
											/>
										</div>
									</div>
								</div>
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Deskripsi Part<span style="color: red;">*</span></label>
											<input type="text" class="input--style-4" v-model="data.part_number"/>
										</div>
									</div>
								</div>
								<div class="row row-space">
									<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
										<div class="input-group">
											<label class="label">Jumlah Sparepart<span style="color: red;">*</span></label>
											<input class="input--style-4" type="number" :step="'1'"  v-model="data.amount">
										</div>
									</div>
								</div>
								<!-- :custom-label="opt => options.brand.find(x => x.id == opt).name" -->
								<div v-if="data.sparepart_id" class="row row-space">
									<div class="col-12">
										<div class="input-group">
											<label class="label">Rincian Sparepart</label>
											<table class="table table-borderless">
												<tr>
													<td>Sparepart ID</td>
													<td>:</td>
													<td>{{data.sparepart_id.id}}</td>
												</tr>
												<tr>
													<td>Group Part</td>
													<td>:</td>
													<td>{{data.sparepart_id.sparepart_variants.sparepart_attachment_id ? options.sparepartAttachments.find( x => x.id == data.sparepart_id.sparepart_variants.sparepart_attachment_id).name : '-'}} Group</td>
												</tr>
											</table>
										</div>
									</div>
								</div>
							</div>

							<div class="row" style="margin-bottom:100px">
								<div class="col mt-5" style="text-align: center">
									<button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
									<button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Tambah</button>
								</div>
							</div>
						</div>
						<!-- End Modal Body -->
					</div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
		</div>
  </div>

 
</transition>
</template>

<script>
import MultiSelect from 'vue-multiselect'
export default {
	components : {
		MultiSelect
	},
	data () {
		return {
			options : this.$store.getters.getFilterOptions,
			sparepart_type: 'J',
			sparepartMaster: null,
			noOfJasa : 1,
			dataJasa : [],
			listJasa : [],
			listPartNumber : [],
			variant_id : null,
			selectPartNumber : null,
			selectSparepart : null,
			addPartNumber : false,
			addPartNumberText : '',
			price : 0,
			addPriceList : 0,
      		formPriceList : null,
			processSparepart : false,
		}
  	},
  	watch : {
		sparepart_type : function() {
			this.data.sparepart_id = null
			this.selectSparepart = null;
			this.data.amount = this.sparepart_type == 'J' ? 1 : 0
			this.data.attachment_id = null;
			this.data.sparepart_size = null;
		},
		'selectSparepart' : function () {
			this.addPartNumber = false
			this.listPartNumber.length = 0
			this.selectPartNumber = null
			if(this.sparepart_type == 'P') {
				this.searchSparepartID(this.selectSparepart , this.sparepart_type)
			}
			else {
				this.searchSparepartID(this.selectSparepart , this.sparepart_type)
			}
		},
		selectPartNumber : function () {
			this.data.sparepart_id = this.selectPartNumber
		},
		'data.price_per_item' : function () {
			const result = this.data.price_per_item.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.data.price_per_item = result);
		}
	},
	computed : {
		'extensionList' : function () {
			if(this.selectSparepart) {
				let listOfExtension = this.sparepartMaster[this.sparepart_type].find(x => x.id == this.selectSparepart).extension
				if(listOfExtension != null) {
					listOfExtension = listOfExtension.split(',')
				}

				return listOfExtension ? listOfExtension : []
			}
			else {
				return ['No Extension Available']
			}

		},
		'descriptionList' : function () {
			if(this.selectSparepart) {
				let listOfDescription = this.sparepartMaster[this.sparepart_type].find(x => x.id == this.selectSparepart).description
				if(listOfDescription != null) {
					listOfDescription = listOfDescription.split(',')
				}

				return listOfDescription ? listOfDescription : []
			}
			else {
				return []
			}
		}
	},
	mounted () {
	// console.log(this.options)  
		this.loadSparepartData()
		this.formPriceList = JSON.parse(JSON.stringify(this.form))
		this.data.amount = 1;
		this.data.ppn_included = false;
	},
	methods : {
		updateDescription (text) {
			this.$set(this.data , 'part_number' , text)
		},
		addPriceListDB () {
			this.formPriceList = Object.assign({} , this.formPriceList)
			this.formPriceList.sparepart_id = this.data.sparepart_id.id

			
			this.formPriceList.price = parseFloat(this.addPriceList)
			if(this.formPriceList.price <= 0) {
				this.$store.dispatch('triggerAlert' , [false , 'Harga Pricelist tidak boleh kosong'])
				return
			}
			delete this.formPriceList.sparepart_size
			delete this.formPriceList.attachment_id
			this.$http.post('/api/v1/insurance/pricelist', this.formPriceList)
			.then((resp )=> {
				this.data.price_per_item = parseFloat(this.addPriceList)
				this.price = this.data.price_per_item
			})
			.catch((err) => {
				console.log(err)
			})
		},
		searchSparepartID (sparepart  , type ) {
			let url = `/api/v1/masterData/sparepart`

			this.$http.get(url + `?variant_id=${this.selectSparepart}`)
			.then((resp) => {
				this.data.sparepart_id = resp.data.data[0]
				this.price = this.insurancePriceList.find(x => x.sparepart_id == this.data.sparepart_id.id)
				this.price = this.price ? this.price : 0
				if(this.sparepart_type == 'J')
					this.data.price_per_item = this.price ? parseFloat(this.price.price) : null
				else {
					delete this.data.price_per_item
					this.data.attachment_id = this.data.sparepart_id.sparepart_variants.sparepart_attachment_id
				}

			})
			.catch((err) => {
				console.log(err)
			})
		},
		loadSparepartData () {
			this.sparepartMaster = null

			let data = {
				J : [],
				P : [],
				B : []
			}
			this.$http.get(`/api/v1/masterData/sparepart/variants?pagination=false`)
			.then((resp) => {
				let sparepartMaster = resp.data.data
				for(var i = 0 ; i < sparepartMaster.length ; i++) {
				if(sparepartMaster[i].sparepart_type.id == 1 && sparepartMaster[i].is_show) {
					data.J.push(sparepartMaster[i])
				}
				else if(sparepartMaster[i].sparepart_type.id == 2) {
					data.P.push(sparepartMaster[i])
				}

				}

				this.sparepartMaster = data
				// console.log(this.sparepartMaster)
			})
			.catch((err) => {console.log(err)})
		},
		validateForm(){
			var valid = true;
			var error = [];
			this.data.amount  = parseFloat(this.data.amount)
			if(this.data.sparepart_id == '' || this.data.sparepart_id == null){//Sparepart [Required]
				valid = false;
				error.push('Sparepart wajib dipilih!');
			}

			if(this.data.amount <= 0 ){//Name [Required]
				valid = false;
				error.push('Jumlah Sparepart tidak boleh 0!');
			}

			if(this.sparepart_type == 'J' && (this.data.sparepart_size == '' || !this.data.sparepart_size)) {
				valid = false;
				error.push('Sparepart Size Tidak Boleh Kosong.');
			}

			if(this.sparepart_type == 'P' && (this.data.part_number == '' || !this.data.part_number)) {
				valid = false;
				error.push('Part Description Tidak Boleh Kosong.');
			}

			if(this.sparepart_type == 'J' && (this.data.price_per_item == '' || !this.data.price_per_item)) {
				valid = false;
				error.push('Harga Jasa Tidak Boleh Kosong.');
			}

			if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        	else return valid;
		},
		async submitForm() {
			if(this.processSparepart) {
				this.$store.dispatch('triggerAlert' , [false , 'Sparepart is processing.. please wait a moment'])
				return
			}
			this.processSparepart = true
			if(this.validateForm()){
				let data = JSON.parse(JSON.stringify(this.data))
				// console.log(data)
				data.sparepart_id = data.sparepart_id.id
				data.sparepart_type = this.sparepart_type
				if(this.sparepart_type == 'P') delete data.sparepart_size
				if(this.sparepart_type == 'J') {
					data.price_per_item = data.price_per_item.toString()
					data.price_per_item = data.price_per_item.includes(',') ?  parseFloat(data.price_per_item.split(',').join('')) : parseFloat(data.price_per_item)
				}
				

				data.attachment_id != null ? data.force_add = true : data.force_add = false;
				
				
				this.$http.post('/api/v1/estimations' , [data])
				.then((resp) => {
					this.$store.dispatch('triggerAlert', [true, [`Sparepart Berhasil Ditambah`]]);
					this.$emit('updateTable');
					this.$emit('closeModal');
				})
				.catch((err) => {

					let errObj = err.response.data.data
					let errMessage = ''
					if(errObj.name == 'DBError') {
						errMessage = errObj.nativeError.sqlMessage
					}
					else {
						errMessage = errObj.message
					}
					// console.log(errObj)

					this.$store.dispatch('triggerAlert' , [false, errMessage])
					this.processSparepart = false
				})
			}
			else {
				this.processSparepart = false
			}
		},
		parseData (data) {
			let returnData = [data]
			for ( var i = 0 ; i < this.dataJasa.length ; i++) {
				let modelData = JSON.parse(JSON.stringify(data))
				modelData.sparepart_id = this.dataJasa[i].id
				modelData.amount = 1
				returnData.push(modelData)
			} 

			return returnData
		}
	},
	props : ['data', 'brand_id', 'insurancePriceList' , 'form']
}
</script>

<style>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
